module.exports = __webpack_public_path__ + "static/Russian Railways-51910dfc253a858aaf770e91c3594677.svg";